module.exports = __webpack_public_path__ + "static/media/consumer-engagement.f041733f.svg";